// Typelizer digest bab3806f2899e0e3115c3f4e9b7a3875
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/overview/month_end_export */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/overview/month_end_export', {}, options),
    method: 'post',
  }),
}
